import { Container, Title, Text } from '@mantine/core'

export function PracticeSetup() {
  return (
    <Container>
      <Title order={2} c="var(--sat-text)">Practice Setup</Title>
      <Text c="var(--sat-green)" mt="md">Coming soon</Text>
    </Container>
  )
}
